/**
 * Divisions that overtime is tracked against on the finance dashboard. The values are the
 * labels HR uses on the weekly OT summary, and `OVERTIME_DIVISIONS` is the fixed display /
 * stack / colour order — never re-sort it, series colours are keyed by position.
 */
export enum OvertimeDivision {
    Metals = 'Metals',
    PlasticsRoto = 'Plastics Roto',
    ToolRoom = 'Tool Room',
    MaintenanceTrucking = 'Maintenance/Trucking',
    Warehouse = 'Warehouse',
    Automation = 'Automation',
}

/** Older rows (and HR's spreadsheet) split roto by cell; they all fold into `PlasticsRoto`. */
export const LEGACY_OVERTIME_DIVISION_MAP: Record<string, OvertimeDivision> = {
    'Plastics Roto-1': OvertimeDivision.PlasticsRoto,
    'Plastics Roto-2': OvertimeDivision.PlasticsRoto,
    'Plastics Roto-3': OvertimeDivision.PlasticsRoto,
};

export const OVERTIME_DIVISIONS: OvertimeDivision[] = [
    OvertimeDivision.Metals,
    OvertimeDivision.PlasticsRoto,
    OvertimeDivision.ToolRoom,
    OvertimeDivision.MaintenanceTrucking,
    OvertimeDivision.Warehouse,
    OvertimeDivision.Automation,
];
